<template>
  <div class="works-detail" v-show="isShow">
    <div class="left-right-content clearfix">
      <div class="c-left">
        <div class="article-top-info">
          <div class="art-top-title">{{ productionObj.productionName }}</div>
          <div class="type-tags">
            <span class="type">{{ productionObj.tagStr }}</span>
            <span
              class="tag"
              v-for="(item, index) in productionObj.tags"
              :key="index"
              >{{ item.tag }}</span
            >
          </div>
          <div class="zc-count clearfix">
            <i class="icon see"></i
            ><span class="much">{{ productionObj.viewCount }}</span>
            <i class="icon pinglun"></i
            ><span class="much">{{ productionObj.commentCount }}</span>
            <i class="icon fenxiang"></i
            ><span class="much">{{ productionObj.shareCount }}</span>
            <!-- <span class="much"><i class="el-icon-more"></i></span> -->
            <span class="tips" v-if="productionObj.isOriginal == 1"
              ><i class="el-icon-warning"></i> 未经作者授权，禁止转载</span
            >
            <span class="date">{{
              productionObj.createTime | formatTime
            }}</span>
          </div>
        </div>


        <div class="article-center-cont">
          <div v-html="productionObj.productionInrto"></div>
          <div v-if="productionObj.productionForm == 1">
            <img
              v-for="(item, index) in picList"
              :key="index"
              :src="item.url"
              alt=""
            />
          </div>
          <div v-else-if="productionObj.videoSource == 1">
            <div class="demand-play" v-if="ccsrc != '1'">
              <cc-video
                :ccsrc="ccsrc"
                :ccPic="ccPic"
                v-if="productionObj.videos.status == 1"
              ></cc-video>
              <div
                class="no-success-add"
                v-if="
                  productionObj.videos.status == 0 ||
                    productionObj.videos.status == 2
                "
              >
                <img
                  class="img-fm"
                  :src="productionObj.productionCover"
                  alt=""
                />
                <i
                  class="no-play-icon"
                  @click="notStatus(productionObj.videos.status)"
                ></i>
              </div>
            </div>
          </div>

          <div v-else v-html="productionObj.videoCode" class="iframe-h"></div>


          <!--   v-if="productionObj.proRelateList.length == 0"   -->
          <div class="me-change-btn" id="me-change-btn"  >
            <!--<p @click="meChange" v-if="isGS">我来改编剧本</p>-->
          </div>

          <div v-for="(item,index) in productionObj.proRelateList" :key="index">
            <work-story v-if="item.production" :tit="item.production.productionName" :proObjIndex="index" :proObjId="item.production.id"></work-story>
          </div>

          <!--<work-story tit="剧本2：剧本名称剧本名称剧本名称剧本名称剧本名称剧本名称"></work-story>
          <work-story tit="剧本3：剧本名称剧本名称剧本名称剧本名称剧本名称剧本名称"></work-story>-->
        </div>


        <div class="articled-zan-cai" v-if="isReloadLikeFlag">
          <div
            class="item"
            :class="{ active: productionObj.likeFlag }"
          >
            <i class="icon zan"></i>
            <span>{{ productionObj.likeCount }}</span>
          </div>
          <div
            class="item"
            :class="{ active: productionObj.disLikeFlag }"
          >
            <i class="icon cai"></i>
            <span>{{ productionObj.dislikeCount }}</span>
          </div>
        </div>

        <!--        <span class="tag" v-for="(item, index) in productionObj.ats" :key="index">#{{item.notifiedUser}}=={{item.notifiedUserName}}#</span>-->

        <div
          class="pro-work-item clearfix"
          style="border-top: 5px solid #f6f6f6;"
        >
          <div class="item-infoes same-left">
            <talkPart
              :objType="1"
              :objId="objId"
              v-if="isReload && isMounted"
              :loadShow="false"
              :isProView="true"
              :isShowCreateTime="false"
            ></talkPart>
          </div>
        </div>

        <div id="proAbout" class="about-works" v-if="aboutTotal >0">相关作品</div>

        <div
          class="pro-work-item clearfix"
          v-for="(item, index) in abortProductionList"
          :key="index"
        >
          <div class="user-avatar">
            <router-link
              :to="{ path: '/home', query: { userId: item.creatorId } }"
              class="avatar-f"
            >
              <img :src="item.imgUrl" alt="" />
            </router-link>
            <!--            <div class="tip-title">推荐</div>-->
          </div>
          <div class="item-infoes">
            <!-- username 和 称号 -->
            <div class="user-name-title clearfix">
              <router-link
                :to="{ path: '/home', query: { userId: item.creatorId } }"
                class="name"
                >{{ item.creatorName }}</router-link
              >
              <div
                class="new-tchh clearfix"
                v-if="item.userRankName != '' && item.userRankName != null"
              >
                <i
                  class="icon zs"
                  v-if="item.userRankName.split(',')[1] == '资深作者'"
                ></i>
                <i
                  class="icon yx"
                  v-if="item.userRankName.split(',')[1] == '优秀作者'"
                ></i>
                <i
                  class="icon hy"
                  v-if="item.userRankName.split(',')[1] == '活跃作者'"
                ></i>
                <span class="zuoz">{{ item.userRankName.split(",")[1] }}</span>
                <span class="shu">|</span>
                <span class="liny">{{ item.userRankName.split(",")[0] }}</span>
              </div>
            </div>
            <!-- 文字 -->
            <div class="user-words">
              <router-link
                :to="{ path: '/worksdetail', query: { id: item.id ,plate:item.belongSection } }"
                target="_blank"
              >
                <div v-html="item.productionInrto"></div>
              </router-link>
            </div>
            <div class="images-list clearfix" v-if="item.productionForm == 1">
              <div
                v-for="(item_bak, index_bak) in item.picList"
                :key="index_bak"
              >
                <router-link
                  :to="{ path: $route.fullPath }"
                  @click.native="toLogWithNextPage(item.id)"
                  class="img-grid"
                  v-if="index_bak < 9"
                  :style="{ 'background-image': 'url(' + item_bak.uri + ')' }"
                ></router-link>
              </div>
            </div>
            <!-- video -->
            <div class="o-video" v-else>
              <router-link
                :to="{ path: $route.fullPath }"
                @click.native="toLogWithNextPage(item.id)"
              >
                <img :src="item.productionCover" alt="" />
                <div class="mask">
                  <i class="el-icon-video-play"></i>
                </div>
              </router-link>
            </div>
            <!-- 类型 关注 标签 -->

            <!--<div class="type-tags" v-if="productionObj.tagStatus">
              <router-link
                :to="{
                  path: '/works',
                  query: {
                    parameTagId: item.productionType,
                    parameTagName: item.tagStr
                  }
                }"
                target="_blank"
              >
                <span class="type">{{ item.tagStr }}</span>
              </router-link>
              <span
                class="tag-item"
                v-for="(item_bak, index_bak) in item.tags"
                :key="index_bak"
              >
                <router-link
                  :to="{
                    path: '/works',
                    query: {
                      parameTagId: item.productionType,
                      parameTagName: item.tagStr,
                      parameTagStr: item_bak.tag
                    }
                  }"
                  target="_blank"
                >
                  {{ item_bak.tag }}
                </router-link>
              </span>
             </div>-->

            <div class="type-tags" > <!--v-else -->
              <span class="type">{{ item.tagStr }}</span>
              <span
                class="tag-item"
                v-for="(item_bak, index_bak) in item.tags"
                :key="index_bak"
              >
                {{ item_bak.tag }}
              </span>
              <!--              <span class="tag-item" v-for="(item_bak, index_bak) in item.tags" :key="index_bak">#<router-link :to="{path:'/works',query:{parameTagId:1,parameTagStr:'化学'}}" target="_blank" >化学</router-link>#</span>-->
            </div>

            <talkPart
              :objType="1"
              :objId="item.id"
              v-if="isReload && isMounted"
              :key="item.id"
              :loadShow="false"
            ></talkPart>
          </div>
        </div>

        <div class="pagintion-f">
          <el-pagination
            background
            @current-change="about"
            layout="prev, pager, next"
            :current-page="abortProductionParam.pageIndex"
            :page-size="abortProductionParam.pageSize"
            :total="aboutTotal"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>

        <!--<pagination align="center" v-show="aboutTotal>0" :total="aboutTotal" :page.sync="abortProductionParam.pageIndex" :limit.sync="abortProductionParam.pageSize"-->
        <!--:pageSizes="abortProductionParam.pageSizes"       @pagination="about"/>-->
      </div>
      <div class="c-right">
        <div class="one-item">
          <div class="detail-userinfo">
            <router-link
              :to="{ path: '/home', query: { userId: userInfo.userId } }"
              class="avatar-f"
              ><img :src="userInfo.imgUrl" alt=""
            /></router-link>
            <div class="user-name">
              <router-link
                :to="{ path: '/home', query: { userId: userInfo.userId } }"
                >{{ userInfo.userName }}</router-link
              >
            </div>
            <div class="chenghao">{{ userInfo.signature }}</div>
            <div class="qianming">{{ userInfo.introduction }}</div>
            <div class="btns" v-if="isLogin && userInfo.userId != loginUserId">
              <el-button
                class="btn wgz-btn"
                v-if="userInfo.followStatus == 0"
                @click="doFollow(userInfo.userId)"
                ><i class="el-icon-plus"></i> 关注</el-button
              >
              <el-button
                class="btn"
                v-else-if="userInfo.followStatus == 1"
                @click="undoFollower(userInfo.userId)"
                >已关注</el-button
              >
              <el-button
                class="btn"
                v-else-if="userInfo.followStatus == 2"
                @click="undoFollower(userInfo.userId)"
                >互相关注</el-button
              >
              <el-button
                class="btn wgz-btn"
                v-if="friendStatus == 4"
                @click="addFriend()"
                ><i class="el-icon-plus"></i> 加好友</el-button
              >
              <!--<el-button
                class="btn"
                @click="toChart(userInfo.userId)"
                v-else-if="friendStatus == 2"
                >发消息</el-button
              >-->
              <el-button
                class="btn"
                v-else-if="friendStatus == 1"
                style="cursor:auto"
                >请求中</el-button
              >
            </div>
            <ul class="much-list clearfix">
              <li>
                <router-link
                  target="_blank"
                  :to="{
                    path: '/home/zuopin',
                    query: { userId: userInfo.userId }
                  }"
                >
                  <span class="tit">作品</span>
                  <span class="count">{{ userInfo.productionsCount }}</span>
                </router-link>
              </li>
              <li>
                <router-link
                  target="_blank"
                  :to="{
                    path: '/home/wenzhang',
                    query: { userId: userInfo.userId }
                  }"
                >
                  <span class="tit">文章</span>
                  <span class="count">{{ userInfo.archivesCount }}</span>
                </router-link>
              </li>
              <li>
                <router-link
                  target="_blank"
                  :to="{
                    path: '/home/fensi',
                    query: { userId: userInfo.userId }
                  }"
                >
                  <span class="tit">粉丝</span>
                  <span class="count">{{ userInfo.followersCount }}</span>
                </router-link>
              </li>
              <li>
                <router-link
                  target="_blank"
                  :to="{
                    path: '/home/guanzhu',
                    query: { userId: userInfo.userId }
                  }"
                >
                  <span class="tit">关注</span>
                  <span class="count">{{ userInfo.followingsCount }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="one-item">
          <div class="one-title">
            其他作品
            <i class="el-icon-refresh-right shuaxin" @click="other"></i>
          </div>
          <div class="works-list">
            <router-link
              :to="{ path: '/workstory', query: { id: item.id ,plate:item.belongSection} }"
              target="_blank"
              class="item"
              :title="item.productionName"
              v-for="(item, index) in otherProductionList"
              :key="index"
            >
              <div class="work-img-f">
                <img :src="item.productionCover" alt="" />
              </div>
              <div class="work-title">{{ item.productionName }}</div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="page-question">
      <transition name="slide-title">
        <div class="fixed-title" v-if="showFixedTitle">
          <div class="cont">
            <span class="copy-title" @click="titBackTop">{{productionObj.productionName}}</span>
            <div class="btns">
              <!--<el-button type="danger" class="tj" @click="meChange"  v-if="isGS">我来改编剧本</el-button>-->
            </div>
          </div>
        </div>
      </transition>
    </div>
    <el-dialog
      top="56px"
      class="dialog-story"
      title="编写剧本"
      :visible.sync="dialogWhiteStory"
      :modal-append-to-body="false"
      :closeOnClickModal="false"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="剧本名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="剧本内容" prop="cont">
          <que-rich-text v-if="isRichReload"
                         ref="richtext"
                         class="item-wrap"
                         v-model="newJBForm.productionInrto"
                         placeholder="问题描述"
          />
          <!--<el-input type="textarea" rows="20" v-model="ruleForm.cont"></el-input>-->
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="saveNewJB" >提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapState } from "vuex";
  import updateTdk from "@/utils/tdk";
  import productionApi from '@/api/production'
  import axios from 'axios';
  import vue from 'vue';
  //import queRichText from '@@/question/pub/richtext'
  import CcVideo from '@@/pub/ccvideo/ccvideo'
  //import tagApi from '@/api/tags'
  vue.prototype.$axios = axios;
  import userInfoApi from '@/api/userInfo'
  import talkPart from '@@/pub/talkpart/talkpart'
  import homeApi from '@/api/home'
  import apiService from '@/api/index'
 // import Pagination from '@/components/Pagination'
  import workStory from './story'


  // import $ from "jquery"
export default {
  components: {
    CcVideo,talkPart//,Pagination
    ,workStory//,queRichText
  },
  data () {
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      headAddInfo:"ddInfo---rrdh",
      isMounted: false, //for control not ssr render

      friendStatus:-1,
      ccReload:true,
      otherTotal:0,
      aboutTotal:0,
      isShow:false,
      isLogin: false,
      loginUserId:0,
      objId:0,
      isReload:true,
      isRichReload:false,
      isReloadLikeFlag: true,
      videoUrl:"",
      ccsrc: "1",
      ccPic:"",
      textCon: '',
      activitiesAnd: false,
      userInfo:{},
      tagParam:{
        deleteFlag: 0,
      },
      productionObj:{},
      production:{
        id:0,
        productionName:'',
        tagStr:'',
        tags:[],
        viewCount:0,
        commentCount:0,//评论数量
        likeCount:0,//点赞数量
        dislikeCount:0,//踩数量
        shareCount:0,//分享数量
        productionInrto:'',//作品简介
        productionForm: '', //1为图片；2为视频；
        productionCover: '',//作品封面
        productionImage: '',//作品图片
        productionVideo: '',//作品视频
        videoSource:"1", //1为本地；2为第三方；
        videoCode:"",//第三方通用代码
        ats:[],
        picList:[],
      },
      productionParam:{
        deleteFlag: 0,
        publishStatus:1,
        pageIndex: 1,
        pageSize: 12,
      },
      otherproductionParam:{
        creatorId:0,
        id:0,
        pageIndex: 1,
        pageSize: 5,
        productionType:0,
        publishStatus:1,
        getType:'other',
        orderType:'hotNum',
      },
      otherProductionList:[],
      abortProductionParam:{
        creatorId:0,
        id:0,
        pageIndex: 1,
        pageSize: 5,
        pageSizes:[5,10,20],
        productionType:0,
        publishStatus:1,
        getType:'about',
        orderType:'hotNum',
      },
      abortProductionList:[],
      showFixedTitle: false,
      dialogWhiteStory: false,
      ruleForm: {
        name: '',
        cont: ''
      },
      rules: {
        name: [{required: true, message: '请输入剧本名称', trigger: 'blur'}],
        cont: [{required: true, message: '请输入剧本内容', trigger: 'blur'}]
      },
      isJB:false,
      isGS:false,
      newJBForm: {
        id:0,
        productionName: '',//作品名称
        productionInrto: '',//作品简介
        productionType: '1',//从字典表提取
        typePath:",",
        productionForm: 3, //1为图片；2为视频；文章
        productionCover: 'http://ocs.21teacher.com/dir-image/2020/11/12/3bf766ff03b44a89b4c78e1d75c9589d.png',//require('@/assets/images/jb.png'),//作品封面
        //productionImage: '',//作品图片
        //productionVideo: '',//作品视频
        //groupType: '',//作品组别
        productionTags: '',//作品标签
        creatorName: '',
        creatorId:0,
        modifierName: '',
        modifierId:0,
        remark: '',
        auditStatus: 1,//审核状态 -- -1为未提交；0为待审核；1为审核通过；2为审核未通过； --管理后台创建的全部为审核通过状态
        publishStatus: 0,//发布状态 --0为未发布；1为发布；
        isOriginal:"1", //0为非原创；1为原创；
        isPublic:"1", //0为私有；1为公开；
        videoName:'',
        courseType:10,
        videoCcId:"",
        videoCcSize:0,
        videoCcExt:"",
        videoCcName:"",
        videoSource: "1", //1为本地；2为第三方；
        videoCode:"",// 通用代码
        sendTo:'',
        belongSection:3, //剧本-----所属板块 传统文化
      },
    }
  },
  computed: {
    ...mapState(["productionDetail"])
  },
  tdk() {
    return {

      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: this.headAddInfo
    };
  },
  serverPrefetch() {
    let id = this.$route.query.id
    if(id){
      this.objId =parseInt(id)
    }
    return this.fetchData();

  },
  destroyed() {
    this.$store.commit("SET_PRODUCTION_DETAIL", { detail: null });
  },

  beforeMount(){
    // 只会在浏览器执行  import queRichText from '@@/question/pub/richtext'
    this.$options.components.queRichText = () =>import('@@/question/pub/richtextForPro');
  },
  mounted() {

    const alreadyIncremented = !!this.productionDetail;
    if (!alreadyIncremented) {
      this.fetchData().then(
              setTimeout(()=>{
                this.initData()
              },500)

      );
    } else {
      setTimeout(()=>{
        this.initData()
      },500)
    }
    this.titleScrollEvent()
    // window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    // window.addEventListener('unload', e => this.unloadHandler(e))
  },
  // created(){
  //   this.setPlayerCallBack();
  // },
  // destroyed() {
  //   window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
  //   window.removeEventListener('unload', e => this.unloadHandler(e))
  // },
  methods:{
    fetchData(){
      return this.$store
              .dispatch("FETCH_PRODUCTION_DETAIL", {
                id: this.$route.query.id
              })
              .finally(() => {
                this.$loading(false);
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initData(){
      let this_ = this
      this.isMounted = true;
      this.isRichReload = true
      window.ccH5PlayerJsLoaded = true;

      window.on_CCH5player_ready = this.onPlayerReady;

      if(this.global.isLogin){
        this_.loginUserId = this.global.userModel.id
        this_.isLogin = true

        this_.newJBForm.creatorId = this_.global.userModel.id
        this_.newJBForm.creatorName = this_.global.userModel.name

      }

      this_.productionObj = this_.productionDetail

      if(this_.productionObj.tagStr.indexOf("故事-") >-1){
        this_.isGS = true
      }else {
        this_.isJB = true
      }

      productionApi.select(this_.productionObj.id).then(data =>{

        this_.productionObj.likeFlag = data.response.likeFlag
        this_.productionObj.likeCount = data.response.likeCount

        this_.productionObj.disLikeFlag = data.response.disLikeFlag
        this_.productionObj.dislikeCount = data.response.dislikeCount

      })


      this_.objId = this_.productionObj.id
      this_.isReload = true

      if(this_.productionObj.deleteFlag==1){
        this.$router.push({
          path:'/error',
        })
      }else{
        this_.isShow = true

        if(this_.productionObj.picList!=null){
          this_.picList = this_.productionObj.picList
        }

        if(this_.productionObj.productionForm == 2){
          if(this_.productionObj.videoSource==1){
            this_.ccsrc=this_.productionObj.productionVideo;
          }
          //this_.ccPic=this_.productionObj.productionCover;
        }

        // this_.$ba.trackEvent("作品","info",this_.productionObj.id+":"+this_.productionObj.productionName)
        // this_.$ba.trackPageview("/works")

        //@列表

       // if(this_.productionObj.ats)
        //作者信息
        userInfoApi.select(this_.productionObj.creatorId).then(reUser => {
          this_.userInfo = reUser.response
        })

        //其他作品
        this_.other()
        //相关作品  不是当前类型的其他作品
        this_.about()
        this_.getFriendStatus()
      }


    },
    doFollow(userId){
      let this_ = this
      homeApi.follower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status >= 1) {
          this_.userInfo.followStatus=status
          this_.$message.success("关注成功")
        } else {
          this_.$message.error("关注失败")
        }
      })
    },
    undoFollower(userId) {
      let _this = this;
      homeApi.undoFollower(userId).then(data => {
        // console.log(data)
        const status = data.response.status
        if (status == 1) {
          _this.userInfo.followStatus=0
          _this.$message.success("取消成功")
        } else {
          _this.$message.error("取消失败")
        }
      })
    },
    other(){
      let this_ = this
      this_.otherproductionParam.creatorId =this_.productionObj.creatorId
      this_.otherproductionParam.id = this_.productionObj.id
      this_.otherproductionParam.productionType = this_.productionObj.productionType


      productionApi.pageList(this_.otherproductionParam).then(reOther => {
        this_.otherProductionList= reOther.list
        this_.otherTotal= reOther.total
        if(this_.otherproductionParam.pageIndex == Math.ceil(this_.otherTotal/this_.otherproductionParam.pageSize) ){
          this_.otherproductionParam.pageIndex =1
        }else{
          this_.otherproductionParam.pageIndex = this_.otherproductionParam.pageIndex+1
        }


      })
    },
    about(page){
      let this_ = this
      this_.abortProductionParam.creatorId =this_.productionObj.creatorId
      this_.abortProductionParam.id = this_.productionObj.id
      this_.abortProductionParam.productionType = this_.productionObj.productionType

      this_.abortProductionParam.pageIndex = page
      productionApi.pageList(this_.abortProductionParam).then(reAbout => {
        //console.log(reAbout.pageNum)
        this_.abortProductionList= reAbout.list
        this_.aboutTotal= reAbout.total
        // this_.abortProductionParam.pageIndex = reAbout.pageNum

        // if(this_.abortProductionParam.pageIndex == Math.ceil(this_.aboutTotal/this_.abortProductionParam.pageSize) ){
        //   this_.abortProductionParam.pageIndex =1
        // }else{
        //   this_.abortProductionParam.pageIndex = this_.abortProductionParam.pageIndex+1
        // }
      })

      //this_.toTop()
    },
    toTop () {
      let el = document.getElementById('proAbout');

      let top= el.offsetTop

      window.scrollTo({
        top: top-60,
        behavior: "smooth"
      })
    },
    /*likeEvent(id){
      var _this =this;
      if(_this.isLogin){
        apiService.dolike({"objectType":1,"objectId":id,"time": new Date().getMilliseconds()}).then(data => {

          // _this.productionObj.likeFlag = !_this.productionObj.likeFlag
          // if(_this.productionObj.likeFlag){
          //   _this.productionObj.likeCount += 1
          // }else{
          //   _this.productionObj.likeCount -= 1
          // }

          _this.initData();

          // 重新渲染组件
          _this.reloadModel()
        })
      }else{
        // _this.$message({
        //   message: '您尚未登录,请登录后操作',
        //   type: 'error'
        // });
        _this.toLog()
      }

    },
    disLikeEvent(id){
      var _this =this;
      if(_this.isLogin) {
        apiService.dislike({"objectType": 1, "objectId": id,"time": new Date().getMilliseconds()}).then(data => {

          // _this.productionObj.disLikeFlag = !_this.productionObj.disLikeFlag
          // if(_this.productionObj.disLikeFlag){
          //   _this.productionObj.dislikeCount += 1
          // }else{
          //   _this.productionObj.dislikeCount -= 1
          // }

          _this.initData();

          // 重新渲染组件
          _this.reloadModel()
        })
      }else{
        // _this.$message({
        //   message: '您尚未登录,请登录后操作',
        //   type: 'error'
        // });
        _this.toLog()
      }
    },*/
    reloadModel(){
      let _this = this
      // 移除组件
      _this.isReload = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      _this.$nextTick(() => {
        _this.isReload = true
      })
    },
    toLog(){
      this.$router.push({
        path:'/login?callback=' + window.location.href,
      })

    } ,
    //转码没成功提示
    notStatus(){
      this.$message.error("视频转码中...请耐心等待")
    },
    //登录并跳转指定页面
    toLogWithNextPage(id){

      let url = "/worksdetail?id="+id+"&plate="+belongSection
      let url2 = '/login?callback=' + "http://"+window.location.host+"/worksdetail?id="+id+"&plate="+belongSection


      if(this.isLogin){
        window.open(url, '_blank');
      }else{
        window.open(url2, '_blank');
      }
    },
    reloadCCPart(){
      let thiss = this
      // 移除组件
      thiss.ccReload = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      thiss.$nextTick(() => {
        thiss.ccReload = true
      })
    },

    setSeo() {
      this.headTitle = this.productionDetail.productionName+"——人人动画网【官网】";

      let keywords = "";
      this.productionDetail.tags.forEach((item) =>{
        keywords = keywords + item.tag +","
      })

      this.headKeywords = keywords;


      let desc = this.productionDetail.productionInrto.replace(/<\/?.+?>/g,"").trim()
      this.headDesc =desc.substr(0,150);

      this.headAddInfo = '<link rel="canonical" href="http://www.renrendonghua.com/worksdetail?id='+this.productionDetail.id+'">'
    },




    getFriendStatus(){
      let _this=this;
      let url="/rrbi/friends/getFriendStatus?userId="+_this.productionObj.creatorId+"&currentUserId="+_this.loginUserId+"&ti="+new Date().getMilliseconds();
      _this.$axios.get(url).then(function(result){
        _this.friendStatus = result.data
      })
    },
    addFriend() {
      let _this = this;
      if (_this.global.isLogin) {
        let url = '/rrbi/friends/add/' + _this.productionObj.creatorId + "?ti=" + new Date().getMilliseconds();
        _this.$axios.get(url).then(function (result) {
          //console.log(result)
          if (result.data.response.code == 1) {
            _this.$message.success(result.data.response.msg)
            _this.friendStatus = 1
          } else {
            _this.$message.error(result.data.response.msg)
          }
        })
      }
    },
    titleScrollEvent () {
      window.addEventListener('scroll', () => {
        let top = document.documentElement.scrollTop
        let elb = document.getElementById('me-change-btn').offsetTop
        if(top > elb - 56){
          this.showFixedTitle = true
        }else{
          this.showFixedTitle = false
        }
      })
    },
    meChange () {

      if(!this.isLogin){
        this.toLog()
      }else {
        this.dialogWhiteStory = true
      }

    },
    titBackTop () {
      window.scrollTo({
        behavior: 'smooth',
        top: 0
      })
    },
    saveNewJB(){
      this.dialogWhiteStory = false
      //获取子组件值
      this.form.productionInrto = this.$refs.richtext.content
    }
  }
}
</script>

<style scoped lang="less">
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
.works-detail {
  padding-top: @NAVHEIGHT;
  .demand-play {
    .container {
      object {
        embed {
          width: 100% !important;
          height: 100vh !important;
        }
      }
      /deep/.ccH5playerBox {
        margin: 5px auto;
      }
      /deep/.ccH5playerBox.ccH5PlayerBoxFixed {
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
        height: 100% !important;
      }
    }
    /deep/.ccH5Poster {
      img {
        width: 100%;
        height: 100%;
      }
    }
    .no-success-add {
      overflow: hidden;
      position: relative;
      margin: 5px auto;
      .img-fm {
        width: 100%;
      }
      .no-play-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -20px 0 0 -20px;
        width: 40px;
        height: 40px;
        background-image: url(../../assets/images/video_play_icon.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
      }
    }
  }
  .about-works {
    padding: 10px;
    line-height: 30px;
    color: #808080;
    font-size: 16px;
    background: #f6f6f6;
  }
}
.dialog-story{
  /deep/.el-dialog{
    margin-bottom: 0;
    max-width: 1300px;
    width: 90%;
    // height: 90%;
  }
}
@media screen and (max-width: 750px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 100% !important;
          height: 250px !important;
        }
      }
      .no-success-add {
        width: 100%;
        // height: 250px;
      }
    }
  }
}
@media screen and (min-width: 751px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 300px !important;
          height: 208px !important;
        }
      }
      .no-success-add {
        width: 300px;
        // height: 208px;
      }
    }
  }
}
@media screen and (min-width: 1024px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 600px !important;
          height: 416px !important;
        }
      }
      .no-success-add {
        width: 600px;
        // height: 416px;
      }
    }
  }
}
@media screen and (min-width: 1250px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 640px !important;
          height: 540px !important;
        }
      }
      .no-success-add {
        width: 640px;
        // height: 540px;
      }
    }
  }
}
@media screen and (min-width: 1366px) {
  .works-detail {
    .demand-play {
      .container {
        /deep/.ccH5playerBox {
          width: 750px !important;
          height: 520px !important;
        }
      }
      .no-success-add {
        width: 750px;
        // height: 520px;
      }
    }
  }
}
//@import "../../assets/less/stylePublic.less";
</style>
